<script setup lang="ts">
import SelectField from "~/templates/elements/form/SelectField.vue";
import { LanguageSelectionLabels } from "~/templates/partials/footer/LanguageSelectionLabels";
const { currentLanguage, availableLanguages, defaultLanguage } = useMagnoliaLanguage();
const { getLabels } = useCommonLabels();

const { path, query, hash } = useRoute();

const selectableLanguages =
  availableLanguages?.value?.map((lang) => {
    const locale = LanguageSelectionLabels[lang];
    return { value: lang, label: `${locale?.label ?? lang} ${locale?.flag} ` };
  }) ?? [];

const selection = ref(currentLanguage.value);
const selectLabels = getLabels("/BWF/languageSelection/", ["label", "placeholder"]);

watch(selection, () => {
  // implicitly remove the first slash by filtering empty segments
  const segments = path.split("/").filter(Boolean);
  // check if the first segment is an available language
  const pathLanguage = availableLanguages.value.find(
    (lang) => lang?.toLowerCase() === segments?.[0]?.toLowerCase(),
  );
  if (pathLanguage) {
    // found an available lang in the path
    if (selection.value === defaultLanguage.value) {
      // remove language as default
      segments.splice(0, 1);
    } else {
      // replace current with new lang
      segments[0] = selection.value;
    }
  } else {
    // no language in the path, prepend new language
    segments.unshift(selection.value);
  }
  const newPath = `/${segments.join("/")}`;
  navigateTo({ path: newPath, hash, query }, { external: true });
});
</script>

<template>
  <SelectField
    v-if="availableLanguages.length > 1"
    v-model="selection"
    :label="selectLabels?.label"
    :options="selectableLanguages"
    class="form-field-grey"
    :placeholder="selectLabels?.placeholder"
    name="lang"
  />
</template>
